import * as CookieConsent from "vanilla-cookieconsent";

const ENDPOINT = "/consent_logs";
const LOGGED_KEY = "sf_consent_logged_id";

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

function alreadyLogged(consentId) {
  try {
    return localStorage.getItem(LOGGED_KEY) === consentId;
  } catch {
    return false;
  }
}

function markLogged(consentId) {
  try {
    localStorage.setItem(LOGGED_KEY, consentId);
  } catch {
    // localStorage unavailable (private mode quota, disabled cookies, etc.)
  }
}

export async function logConsent(event) {
  const cookie = CookieConsent.getCookie();
  const prefs = CookieConsent.getUserPreferences();

  if (!cookie?.consentId) return;

  // Backfill dedup: "existing" fires on every page load with prior consent,
  // skip when we've already POSTed this consent_id from this browser.
  if (event === "existing" && alreadyLogged(cookie.consentId)) return;

  const payload = {
    consent_id: cookie.consentId,
    accept_type: prefs.acceptType,
    accepted_categories: prefs.acceptedCategories || [],
    rejected_categories: prefs.rejectedCategories || [],
    event,
    language: document.documentElement.lang || "sk",
  };

  try {
    const response = await fetch(ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });

    if (response.ok) {
      markLogged(cookie.consentId);
    }
  } catch (err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn("[cookie-consent] backend log failed:", err);
    }
  }
}
